import { createSlice } from '@reduxjs/toolkit';
import api from '../services/api';
import { logoutReducer, updateAuthReducer } from './reducers';
import { AuthSliceState } from './types';
import { AuthCookies } from '../../utils/auth-cookies';

const initialState: AuthSliceState = {
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    login: updateAuthReducer,
    logout: logoutReducer,
    update: updateAuthReducer,
  },
  extraReducers: (builder) => {
    builder.addMatcher(api.endpoints.googleLogin.matchFulfilled, updateAuthReducer);
    builder.addMatcher(api.endpoints.emailLogin.matchFulfilled, updateAuthReducer);
    builder.addMatcher(api.endpoints.validateToken.matchFulfilled, updateAuthReducer);
    builder.addMatcher(api.endpoints.register.matchFulfilled, updateAuthReducer);
    builder.addMatcher(api.endpoints.emailRegister.matchFulfilled, updateAuthReducer);
    builder.addMatcher(api.endpoints.updateUser.matchFulfilled, updateAuthReducer);
    builder.addMatcher(api.endpoints.deleteAccount.matchFulfilled, logoutReducer);
  },
});

const getUser = (state: AuthSliceState) => state && state.user;

const isNewUser = (state: AuthSliceState) =>
  state && state.user !== null && state.user.new === true;

const credentials = (state: AuthSliceState) => {
  const uuid = state.user?.uuid ?? '';
  return {
    token: AuthCookies.getToken(),
    uuid: uuid === AuthCookies.getUUID() ? uuid : '',
  };
}

const isLogged = (state: AuthSliceState) => {
  const { token, uuid } = credentials(state);
  return state && !!state.user && !!token && !!uuid;
}

const isPremium = (state: AuthSliceState) => state && state.user && state.user.isPremium;

export default authSlice;

export const actions = authSlice.actions;
export const selectors = {
  getUser,
  isLogged,
  credentials,
  isNewUser,
  isPremium,
};
